export const environment = {
  production: false,
  api: 'https://api-safetrack.safetrace.com.br',
  gpaUrl: 'https://safetrack.safetrace.com.br'
};
